(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.filter('SearchUserColumnFilter', [SearchUserColumnFilterFn]);

    // removes items where user is different
    function SearchUserColumnFilterFn() {
        return function (items, searchUser) {
            if (items) {
                if (searchUser === null || typeof searchUser === 'undefined') {
                    return items;
                } // if

                return items.filter(function (item) {
                    // new items always show here...
                    if (item.vmNew === true) return true;
                    // just show item if user is equal
                    if (item.caption == null) {
                        return item.userDto.caption.toLowerCase().indexOf(searchUser.caption.toLowerCase()) !== -1;
                    }
                    let r = (!searchUser.caption || (item.userDto.caption.toLowerCase().indexOf(searchUser.caption.toLowerCase()) !== -1)) &&
                        (!searchUser.otherCaption ||(item.caption.toLowerCase().indexOf(searchUser.otherCaption.toLowerCase()) !== -1));
                    return r;
                });
            }// if
        };
    }
})();
